import { render, staticRenderFns } from "./PopUpModal.vue?vue&type=template&id=6f859eb8"
import script from "./PopUpModal.vue?vue&type=script&lang=js"
export * from "./PopUpModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports